import { render, staticRenderFns } from "./guestAppointmentLayout.vue?vue&type=template&id=56c01e6a&scoped=true"
import script from "./guestAppointmentLayout.vue?vue&type=script&lang=js"
export * from "./guestAppointmentLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c01e6a",
  null
  
)

export default component.exports